import PropTypes from 'prop-types'
import { ControlFlags } from '../../models/common/control-flags-enum'

/**
 * @readonly
 * @enum {string}
 */
export const DRIVER_CONTROL_FLAGS = {
    [ControlFlags.EDIT_DRIVER]: ControlFlags.EDIT_DRIVER,
    [ControlFlags.ACTIVATE_DRIVER]: ControlFlags.ACTIVATE_DRIVER,
    [ControlFlags.DEACTIVATE_DRIVER]: ControlFlags.DEACTIVATE_DRIVER,
    [ControlFlags.ASSIGN_OBJECT_MANUALLY]: ControlFlags.ASSIGN_OBJECT_MANUALLY,
    [ControlFlags.UNASSIGN_OBJECT_MANUALLY]: ControlFlags.UNASSIGN_OBJECT_MANUALLY,
    [ControlFlags.CHANGE_DRIVER_GROUP_MEMBERSHIP]: ControlFlags.CHANGE_DRIVER_GROUP_MEMBERSHIP
}
Object.freeze(DRIVER_CONTROL_FLAGS)

/**
 * @typedef {DRIVER_CONTROL_FLAGS} DriverControlFlags
 */

export const driverControlFlagsPropType = PropTypes.arrayOf(PropTypes.oneOf(Object.values(DRIVER_CONTROL_FLAGS)))
